import { render, staticRenderFns } from "./FeedBackForm.vue?vue&type=template&id=1497e8ca&scoped=true"
import script from "./FeedBackForm.vue?vue&type=script&lang=ts"
export * from "./FeedBackForm.vue?vue&type=script&lang=ts"
import style0 from "./FeedBackForm.vue?vue&type=style&index=0&id=1497e8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1497e8ca",
  null
  
)

export default component.exports